import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
export const ActivityHeatmapQuerySchema = z
    .object({
    days: z.coerce.number().int().min(1).max(365).default(84),
})
    .openapi('ActivityHeatmapQuery');
export const ActivityHeatmapCellSchema = z
    .object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    sessionCount: z.number().int().min(0),
})
    .openapi('ActivityHeatmapCell');
export const ActivityHeatmapResponseSchema = z
    .object({
    days: z.number().int(),
    cells: z.array(ActivityHeatmapCellSchema),
})
    .openapi('ActivityHeatmapResponse');
//# sourceMappingURL=activity-heatmap.schema.js.map